/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { OrderPredictionItem } from './OrderPredictionItem';
// @ts-ignore
import {
// @ts-ignore
    OrderPredictionItemFromJSON,
// @ts-ignore
    OrderPredictionItemFromJSONTyped,
// @ts-ignore
    OrderPredictionItemToJSON,
} from './OrderPredictionItem';

/**
 * 
 * @export
 * @interface OrderPredictionResponse
 */
export interface OrderPredictionResponse {
    /**
     * 
     * @type {string}
     * @memberof OrderPredictionResponse
     */
    predictionId: string;
    /**
     * Date for which the predicted order quantities are intended (e.g., expected delivery or replenishment date)
     * @type {Date}
     * @memberof OrderPredictionResponse
     */
    targetDate: Date;
    /**
     * 
     * @type {string}
     * @memberof OrderPredictionResponse
     */
    storeId: string;
    /**
     * 
     * @type {Date}
     * @memberof OrderPredictionResponse
     */
    deliveryDate?: Date;
    /**
     * Last date of historical data used for prediction
     * @type {Date}
     * @memberof OrderPredictionResponse
     */
    historyEndDate?: Date;
    /**
     * 
     * @type {Array<OrderPredictionItem>}
     * @memberof OrderPredictionResponse
     */
    items: Array<OrderPredictionItem>;
}

/**
 * Check if a given object implements the OrderPredictionResponse interface.
 */
// @ts-ignore
export function instanceOfOrderPredictionResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "predictionId" in value;
    isInstance = isInstance && "targetDate" in value;
    isInstance = isInstance && "storeId" in value;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

// @ts-ignore
export function OrderPredictionResponseFromJSON(json: any): OrderPredictionResponse {
    return OrderPredictionResponseFromJSONTyped(json, false);
}

// @ts-ignore
export function OrderPredictionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderPredictionResponse {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'predictionId': json['prediction_id'],
        'targetDate': (new Date(json['target_date'])),
        'storeId': json['store_id'],
        'deliveryDate': !exists(json, 'delivery_date') ? undefined : (new Date(json['delivery_date'])),
        'historyEndDate': !exists(json, 'history_end_date') ? undefined : (new Date(json['history_end_date'])),
        'items': ((json['items'] as Array<any>).map(OrderPredictionItemFromJSON)),
    };
}

// @ts-ignore
export function OrderPredictionResponseToJSON(value?: OrderPredictionResponse | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'prediction_id': value.predictionId,
        'target_date': (value.targetDate.toISOString()),
        'store_id': value.storeId,
        'delivery_date': value.deliveryDate === undefined ? undefined : (value.deliveryDate.toISOString()),
        'history_end_date': value.historyEndDate === undefined ? undefined : (value.historyEndDate.toISOString()),
        'items': ((value.items as Array<any>).map(OrderPredictionItemToJSON)),
    };
}

